export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8189.b6f23333.jpg";